import { useAuthContext } from "src/auth/AuthContext";
import CommitmentsForm from "./CommitmentsForm";
import { commitmentService } from 'src/service/CommitmentService';

const CommitmentsAdd = () => {
    const { user } = useAuthContext();
    return <CommitmentsForm commitmentId={-1} organizationId={user.data.organizationId} onSubmit={(ps) => commitmentService.add(ps)} header='Neue Zusage' />
}

export default CommitmentsAdd